import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import {
  IContext,
  IGetOrganizationChartResponse,
} from '../model/prepare.interface';
import config from '../../../../../../config.js';

@Injectable({
  providedIn: 'root',
})
export class PrepareService {
  baseUrl = config.API_GATEWAY_ENDPOINT;

  constructor(private http: HttpClient) {}

  async getContext(scenarioId: string): Promise<IContext> {
    const context = lastValueFrom(
      this.http.get<IContext>(`${this.baseUrl}/prepare/context/${scenarioId}`)
    );
    return context;
  }

  async getOrganizationChart(scenario_id:string): Promise<IGetOrganizationChartResponse> {
    const organizationChart = lastValueFrom(
      this.http.get<IGetOrganizationChartResponse>(
        `${this.baseUrl}/prepare/organization-chart/${scenario_id}`
      )
    );

    return await organizationChart;
  }
}
